<template>
  <b-card title="Последние комментарии игроков" class="h-100">
    <div v-if="!safeComments.length" class="text-center text-muted py-2">Комментариев за 4 недели нет</div>
    <div v-for="(item, index) in safeComments" :key="index" class="py-75 border-bottom">
      <div class="d-flex justify-content-between font-small-3 text-muted">
        <span>{{ item.player }} · {{ item.pack }} · {{ item.host }}</span>
        <span>
          <b-badge v-if="item.game_rating != null" :variant="`light-${ratingVariant(item.game_rating)}`">{{ item.game_rating }}</b-badge>
          {{ formatDate(item.date) }}
        </span>
      </div>
      <div class="mt-25">{{ item.comment }}</div>
    </div>
    <b-link :to="{ name: 'feedback-stats' }" class="d-block mt-1 font-small-3">Все отзывы →</b-link>
  </b-card>
</template>

<script>
import { BCard, BBadge, BLink } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatDate } from '@/views/dashboard/sifnf/utils'

export default {
  components: { BCard, BBadge, BLink },
  props: {
    comments: { type: Array, default: () => [] },
  },
  setup(props) {
    const safeComments = computed(() => props.comments || [])
    const ratingVariant = rating => {
      if (rating >= 4.5) return 'success'
      return rating >= 3.5 ? 'warning' : 'danger'
    }
    return { safeComments, ratingVariant, formatDate }
  },
}
</script>
